export namespace NBaseTypes {
  export const STATUSES_WIDGET = 'STATUSES_WIDGET';
  export const STATUSES_WIDGET_TITLE = 'STATUSES_WIDGET_TITLE';
}

export enum TENDER_TYPE {
  WAS = 'WAS',
  CAM = 'CAM',
}

export const TENDER_TYPE_TITLE: Record<TENDER_TYPE, string> = {
  [TENDER_TYPE.WAS]: 'Выполнение работ, оказание услуг',
  [TENDER_TYPE.CAM]: 'Закупка ТМЦ',
};

export enum TENDER_STATE {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  CONFIRM_PARTICIPATION = 'CONFIRM_PARTICIPATION',
  ACCEPT_PROPOSALS = 'ACCEPT_PROPOSALS',
  ACCEPT_PROPOSALS_FINISHED = 'ACCEPT_PROPOSALS_FINISHED',
  ADMIT_PARTICIPANTS = 'ADMIT_PARTICIPANTS',
  ANALYSIS = 'ANALYSIS',
  RESULTS = 'RESULTS',
  CANCELLED = 'CANCELLED',
  FINISHED = 'FINISHED',
}

export const TENDER_STATE_TITLE: Record<TENDER_STATE, string> = {
  [TENDER_STATE.DRAFT]: 'Черновик',
  [TENDER_STATE.PUBLISHED]: 'Опубликован',
  [TENDER_STATE.CONFIRM_PARTICIPATION]: 'Подтверждение участия',
  [TENDER_STATE.ACCEPT_PROPOSALS]: 'Прием предложений',
  [TENDER_STATE.ACCEPT_PROPOSALS_FINISHED]: 'Прием предложений завершен',
  [TENDER_STATE.ADMIT_PARTICIPANTS]: 'Допуск участников',
  [TENDER_STATE.ANALYSIS]: 'Анализ предложений',
  [TENDER_STATE.RESULTS]: 'Подведение итогов',
  [TENDER_STATE.CANCELLED]: 'Отменен',
  [TENDER_STATE.FINISHED]: 'Завершен',
};

export type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends object ? DeepPartial<T[K]> : T[K];
};
